import { render, staticRenderFns } from "./SignupAuto.vue?vue&type=template&id=2d4cb9e1"
import script from "./SignupAuto.vue?vue&type=script&lang=js"
export * from "./SignupAuto.vue?vue&type=script&lang=js"
import style0 from "./SignupAuto.vue?vue&type=style&index=0&id=2d4cb9e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports